import React, { useState, useEffect, Fragment } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import ImageDetailModal from "./ImageDetailModal";

const ImagesModal = (props) => {
  const { items = [], itemIndex } = props;
  const [activeTab, setActiveTab] = useState("all");
  const [showingTrans, setShowingTrans] = useState(false);
  const [openImgIndex, setOpenImgIndex] = useState(props.itemIndex);
  const handleClose = (e, idx) => {
    if (e && idx && idx > 1) {
      props.onCancel(idx);
    }
    setOpenImgIndex(null);
  };
  useEffect(() => {
    if(document.querySelector('.skiptranslate')) {
      setShowingTrans(true);
    }
    setOpenImgIndex(props.itemIndex);
  }, [props.itemIndex]);
  const talentImages = items.filter((item) => item.type === "talent");
  const interiorImages = items.filter((item) => item.type === "interior");
  const filteredImages =
    !activeTab || activeTab === "all"
      ? [...items]
      : items.filter((item) => item.type === activeTab);

  return (
    <Fragment>
      <Modal
        className={`gallery-listing-images ${showingTrans ? 'has-gtranslate' : ''}`}
        fullscreen
        isOpen={props.isOpen}
      >
        <ModalHeader toggle={(e) => props.onCancel()}>
          Photos for {props.listing?.name}
        </ModalHeader>
        <ModalBody>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a href="#" className={`nav-link ${(!activeTab || activeTab === 'all') ? 'active' : ''}`} onClick={e => setActiveTab('all')}>All</a>
            </li>

            {
              talentImages.length > 0 &&  <li className="nav-item">
              <a href="#" className={`nav-link ${activeTab === 'talent'  ? 'active' : '' }`} onClick={e => setActiveTab('talent')}>Talents</a>
            </li>
            }
           
            {
              interiorImages.length > 0 && <li className="nav-item">
              <a href="#" className={`nav-link ${activeTab === 'interior' ? 'active' : ''}`}  onClick={e => setActiveTab('interior')}>Interior/Exterior</a>
            </li>
            }
            
          </ul>

          <div className="tab-content">
            <div className="tab-pane active">
              <div className="listing-gallery-images">
                {filteredImages.map((item, idx) => (
                  <div
                    key={`itm-${idx}-${item.image_url}`}
                    className="listing-gallery-item"
                    onClick={(e) => setOpenImgIndex(idx)}
                  >
                    <img
                      src={item.image_url}
                      alt=""
                      className="listing-gallery-image"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ImageDetailModal
        isOpen={openImgIndex != null && openImgIndex !== undefined}
        imgIndex={openImgIndex}
        items={filteredImages}
        onCancel={handleClose}
      />
    </Fragment>
  );
};

export default ImagesModal;
